import * as React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { Autocomplete, Popover, Button, Stack, TextField, Container } from '@mui/material';

// Calendario
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ptLocale from 'date-fns/locale/pt-BR';

import { getUsuarios, getClientes, getFluxogramas, getUsuariosMontador, getGenericData } from './api';
import { useUnidades } from '../hooks/useUnidades';

const origem = [{ nome: 'Prospecção' }, { nome: 'Agendamento' }, { nome: 'Lead' }, { nome: 'Indicação' }];
// ----------------------------------------------------------------------

// eslint-disable-next-line no-unused-vars
const PopoverFiltro = React.forwardRef((props, ref) => {
  const currentLocation = useLocation();
  const [filtro, setFiltro] = useState(props.filtro);
  const [usuarios, setUsuarios] = useState([]);
  const [montadores, setMontadores] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [estados, setEstados] = useState([]);
  const [cidades, setCidades] = useState([]);
  const status = [{ nome: 'Aprovado' }, { nome: 'Rejeitado' }, { nome: 'Finalizado' }];
  const [fluxos, setFluxos] = useState([]);
  const [etapas, setEtapas] = useState([]);
  const { unidades } = useUnidades();
  const [motivos, setMotivos] = useState([]);
    useEffect(() => {
      const getMotivos = async () => {
        const result = await getGenericData('motivorejeicao', {});
        setMotivos(result);
      };
      getMotivos();
    }, []);
  

  useEffect(() => {
    fectchUsuarios();
  }, []);
  const fectchUsuarios = async () => {
    const resultado = await getUsuarios();
    setUsuarios(resultado);
  };

  useEffect(() => {
    fectchUsuariosMontador();
  }, []);
  const fectchUsuariosMontador = async () => {
    const resultado = await getUsuariosMontador();
    setMontadores(resultado);
  };

  useEffect(() => {
    fetchClientes();
  }, []);
  const fetchClientes = async () => {
    const resultado = await getClientes();
    setClientes(resultado);
  };

  useEffect(() => {
    fetchEstados();
  }, []);
  const fetchEstados = async () => {
    fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Erro na solicitação');
        }
        return response.json();
      })
      .then((estados) => {
        const estadosOrdenados = estados.sort((a, b) => a.nome.localeCompare(b.nome));
        setEstados(estadosOrdenados);
      })
      .catch((error) => {
        console.error('Erro ao obter os estados:', error);
      });
  };

  useEffect(() => {
    fetchCidades();
  }, [filtro.estado]);
  const fetchCidades = () => {
    if (filtro.estado) {
      fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${filtro.estado.sigla}/municipios`)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Erro na solicitação');
          }
          return response.json();
        })
        .then((cidades) => {
          const cidadesOrdenados = cidades.sort((a, b) => a.nome.localeCompare(b.nome));
          setCidades(cidadesOrdenados);
        })
        .catch((error) => {
          console.error('Erro ao obter os estados:', error);
        });
    }
  };

  useEffect(() => {
    fetchFluxogramas();
  }, []);
  const fetchFluxogramas = async () => {
    let resultado = await getFluxogramas();

    if (currentLocation.pathname === '/propostas2') {
      // Filtrar para manter apenas os fluxos com id 3,4
      resultado = resultado.filter((fluxo) => [3, 4].includes(fluxo.id));
    }

    setFluxos(resultado);
  };

  useEffect(() => {
    fetchEtapas();
  }, [filtro.fluxo]);
  const fetchEtapas = () => {
    setEtapas(filtro.fluxo?.etapas);
  };

  // Calendario
  // Calendario 1 (Data Inicial)
  const [openCalendar1, setOpenCalendar1] = useState(false);
  const handleCalendarOpen1 = () => {
    setOpenCalendar1(true);
  };
  const handleCalendarClose1 = () => {
    setOpenCalendar1(false);
  };
  const handleDateChange1 = (date) => {
    setFiltro({ ...filtro, datainicial: date });
    handleCalendarClose1(); // Feche o calendário após a seleção da data
  };

  // Calendario 2 (Data Final)
  const [openCalendar2, setOpenCalendar2] = useState(false);
  const handleCalendarOpen2 = () => {
    setOpenCalendar2(true);
  };
  const handleCalendarClose2 = () => {
    setOpenCalendar2(false);
  };
  const handleDateChange2 = (date) => {
    setFiltro({ ...filtro, datafinal: date });
    handleCalendarClose2(); // Feche o calendário após a seleção da data
  };
  // Calendario

  const handleConfirm = () => {
    props.onConfirm(filtro);
  };
  return (
    <Popover
      open={Boolean(props.open)}
      anchorEl={props.open}
      onClose={props.onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          p: 1,
          width: 'auto+10',
          height: '100%',
          flex: 1,
          display: 'flex',
          '& .MuiMenuItem-root': {
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
          },
        },
      }}
    >
      <Stack flex={1} gap={1} sx={{ height: 'auto' }}>
        <Stack direction={'row'} gap={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptLocale}>
            <DatePicker
              open={openCalendar1}
              onOpen={handleCalendarOpen1}
              onClose={handleCalendarClose1}
              value={filtro.datainicial}
              onChange={handleDateChange1}
              renderInput={(params) => <TextField {...params} label="Data Inicial" />}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptLocale}>
            <DatePicker
              open={openCalendar2}
              onOpen={handleCalendarOpen2}
              onClose={handleCalendarClose2}
              value={filtro.datafinal}
              onChange={handleDateChange2}
              renderInput={(params) => <TextField {...params} label="Data Final" />}
            />
          </LocalizationProvider>
        </Stack>

        <Autocomplete
          disablePortal
          disabled={!JSON.parse(localStorage.getItem('userData')).supervisor}
          id="user"
          value={filtro.usuarioLogado}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, usuarioLogado: newValue });
          }}
          options={usuarios}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} label="Usuário Geral" />}
        />

        <Autocomplete
          disablePortal
          disabled={!JSON.parse(localStorage.getItem('userData')).supervisor}
          id="user"
          value={filtro.user}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, user: newValue });
          }}
          options={usuarios}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} label="Selecione o Usuário" />}
        />
        <Autocomplete
          disablePortal
          disabled={!JSON.parse(localStorage.getItem('userData')).supervisor}
          id="user2"
          value={filtro.user2}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, user2: newValue });
          }}
          options={usuarios}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} label="Selecione o Usuário Abertura" />}
        />

        <Autocomplete
          disablePortal
          disabled={!JSON.parse(localStorage.getItem('userData')).supervisor}
          id="montador"
          value={filtro.montador}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, montador: newValue });
          }}
          options={montadores}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} label="Selecione o Montador" />}
        />

        <Autocomplete
          disablePortal
          id="cliente"
          value={filtro.cliente}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, cliente: newValue });
          }}
          options={clientes}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome} - ${option.cpf}`}
          renderInput={(params) => <TextField {...params} label="Selecione o Cliente" />}
        />

        <Autocomplete
          disablePortal
          id="estado"
          value={filtro.estado}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, estado: newValue });
          }}
          options={estados}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} label="Selecione o Estado" />}
        />

        <Autocomplete
          disablePortal
          id="cidade"
          value={filtro.cidade}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, cidade: newValue });
          }}
          options={cidades}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} label="Selecione a Cidade" />}
        />

        <Autocomplete
          disablePortal
          id="status"
          value={filtro.status}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, status: newValue });
          }}
          options={status}
          isOptionEqualToValue={(option, value) => option.nome === value.nome}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} label="Selecione o Status" />}
        />
        {filtro.status?.nome === 'Rejeitado' && (
          <Autocomplete
            disablePortal
            id="status"
            value={filtro.motivoRejeicao}
            onChange={(event, newValue) => {
              setFiltro({ ...filtro, motivoRejeicao: newValue });
            }}
            options={motivos}
            isOptionEqualToValue={(option, value) => option._id === value._id}
            getOptionLabel={(option) => `${option.nome}`}
            renderInput={(params) => <TextField {...params} label="Selecione o Motivo" />}
          />
        )}
        {currentLocation.pathname !== '/propostas3' && (
          <Autocomplete
            disablePortal
            id="fluxo"
            value={filtro.fluxo}
            onChange={(event, newValue) => {
              setFiltro({ ...filtro, fluxo: newValue });
            }}
            options={fluxos}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.nome}`}
            renderInput={(params) => <TextField {...params} label="Selecione o Fluxo" />}
            disabled={currentLocation.pathname === '/propostas3'}
          />
        )}

        {currentLocation.pathname !== '/propostas3' && filtro.fluxo && (
          <Autocomplete
            disablePortal
            id="etapa"
            value={filtro.etapa}
            onChange={(event, newValue) => {
              setFiltro({ ...filtro, etapa: newValue });
            }}
            options={etapas}
            isOptionEqualToValue={(option, value) => option.nome === value.nome}
            getOptionLabel={(option) => `${option.nome}`}
            renderInput={(params) => <TextField {...params} label="Selecione a Etapa" />}
          />
        )}

        <Autocomplete
          disablePortal
          id="responsavel"
          value={filtro.responsavel}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, responsavel: newValue });
          }}
          options={usuarios}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} label="Selecione o Responsável" />}
        />

        <Autocomplete
          disablePortal
          id="origem"
          value={filtro.origem || null}
          options={origem}
          isOptionEqualToValue={(option, value) => option.nome === value.nome}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} label="Origem" />}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, origem: newValue });
          }}
        />

        <Autocomplete
          disablePortal
          id="unidade"
          value={filtro.unidade || null}
          options={unidades}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} label="Unidade" />}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, unidade: newValue });
          }}
        />

        <Container sx={{ marginTop: 2 }}>
          <Stack direction={'row'} justifyContent={'space-between'}>
            <Button variant={'outlined'} onClick={props.onLimpar}>
              Limpar
            </Button>

            <Button variant={'contained'} color={'success'} onClick={handleConfirm}>
              Filtrar
            </Button>
          </Stack>
        </Container>
      </Stack>
    </Popover>
  );
});

PopoverFiltro.propTypes = {
  open: PropTypes.object,
  onClose: PropTypes.func,
  onLimpar: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default PopoverFiltro;